import { render } from "./add-quotations-modal.vue?vue&type=template&id=f6fc9640"
import script from "./add-quotations-modal.vue?vue&type=script&lang=js"
export * from "./add-quotations-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__